export const helmetProps = {
  title: 'Loan Progress Milestones',
};

export const contentOptions = {
  isScrollable: false,
};

export const MilestonesTab = {
  CONSEQUENT: 'consequent',
  PERMANENT: 'permanent',
};

export const DEFAULT_MILESTONES_TAB = MilestonesTab.CONSEQUENT;

export const MILESTONES_TAB_VALUES = new Set(Object.values(MilestonesTab));

export const MILESTONES_TAB_DESCRIPTIONS = {
  [MilestonesTab.CONSEQUENT]:
    'Consequent milestones are the sequential steps a loan moves through as it progresses. They are ordered and mutually exclusive, and when enabled they are shown in the loan progress widget so users can see the current stage and what comes next.',
  [MilestonesTab.PERMANENT]:
    'Permanent milestones are notable events that can happen at any time during the loan lifecycle and may occur more than once. They appear in the loan progress widget only after they have been reached and remain visible from that point on.',
};

export const MILESTONES_TAB_DEFINITIONS = [
  { label: 'Consequent Milestones', value: MilestonesTab.CONSEQUENT },
  { label: 'Permanent Milestones', value: MilestonesTab.PERMANENT },
];
